import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.79999 10L19.8 10",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("rect", {
      width: "18",
      height: "3",
      rx: "1",
      transform: "matrix(4.37114e-08 1 1 -4.37114e-08 5.79999 1)",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      width: "10",
      height: "3",
      rx: "1",
      transform: "matrix(4.37114e-08 1 1 -4.37114e-08 12.8 5)",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }